import PropTypes from 'prop-types';
import styles from './FJVoiceCloning.module.less';
import FJCreateVoiceCloningContainer from '../container/FJCreateVoiceCloningContainer.jsx';
import FJVoiceCloningListContainer from '../container/FJVoiceCloningListContainer.jsx';
import FJConstant from '../../../constants/FJConstant.js';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';

const FJVoiceCloning = props => {
    const { createCloneStatus } = props;
    return (
        <div className={styles.box}>
            {createCloneStatus === FJConstant.HISTORY_LIST ? (
                <FJVoiceCloningListContainer />
            ) : (
                <FJVerticalScroller style={{ height: '100%', position: 'relative' }}>
                    <FJCreateVoiceCloningContainer />
                </FJVerticalScroller>
            )}
        </div>
    );
};

FJVoiceCloning.propTypes = {
    createCloneStatus: PropTypes.string,
};
export default FJVoiceCloning;
